// extracted by mini-css-extract-plugin
export var brand = "_be-9";
export var compact = "_be-6";
export var extraSmall = "_be-7";
export var icon = "_be-0";
export var large = "_be-4";
export var light = "_be-1";
export var medium = "_be-5";
export var outline = "_be-b";
export var primaryDark = "_be-a";
export var primaryLight = "_be-8";
export var primaryModern = "_be-c";
export var success = "_be-2";
export var successSolid = "_be-3";